import { useMutation } from "@tanstack/react-query";
import BinApiService from "src/api/BinApiService";


export const useUploadBinStateToAzure = (binId: number) => {
    return useMutation({
      mutationFn: async () => {
        return await BinApiService.uploadBinStateToAzure(binId);
      }
    });
  }
  